import { createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<h1 class=\"anchor fw-bolder mb-5\"><a href=\"#spacer\"></a> Spacer </h1><div class=\"py-5\"> Sometimes we want something more than blank space, so we have (spacer) to help us. </div><h2 class=\"anchor fw-bolder mb-5\"><a href=\"#literal-type-spacer\"></a> Literal type spacer </h2>", 3)
const _hoisted_5 = { class: "rounded border p-10" }
const _hoisted_6 = { class: "mb-10" }
const _hoisted_7 = /*#__PURE__*/_createVNode("h2", { class: "anchor fw-bolder mb-5" }, [
  /*#__PURE__*/_createVNode("a", { href: "#spacer-can-also-be-vnode" }),
  /*#__PURE__*/_createTextVNode(" Spacer can also be VNode ")
], -1)
const _hoisted_8 = { class: "rounded border p-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_space = _resolveComponent("el-space")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode("div", _hoisted_5, [
        _createVNode(_component_el_space, {
          size: _ctx.size,
          spacer: "|"
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_Fragment, null, _renderList(2, (i) => {
              return _createVNode("div", { key: i }, [
                _createVNode(_component_el_button, null, {
                  default: _withCtx(() => [
                    _createTextVNode(" button " + _toDisplayString(i), 1)
                  ]),
                  _: 2
                }, 1024)
              ])
            }), 64))
          ]),
          _: 1
        }, 8, ["size"]),
        _createVNode(_component_CodeHighlighter, { lang: "html" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.literalCode6), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode("div", _hoisted_6, [
      _hoisted_7,
      _createVNode("div", _hoisted_8, [
        _createVNode(_component_el_space, {
          size: _ctx.size,
          spacer: _ctx.spacer
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_Fragment, null, _renderList(2, (i) => {
              return _createVNode("div", { key: i }, [
                _createVNode(_component_el_button, null, {
                  default: _withCtx(() => [
                    _createTextVNode(" button " + _toDisplayString(i), 1)
                  ]),
                  _: 2
                }, 1024)
              ])
            }), 64))
          ]),
          _: 1
        }, 8, ["size", "spacer"]),
        _createVNode(_component_CodeHighlighter, { lang: "html" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.spacerCode6), 1)
          ]),
          _: 1
        })
      ])
    ])
  ], 64))
}